import { create } from 'zustand'
import { deleteTour, listTours, putTour } from '../lib/db'
import type { Tour } from '../lib/models'
import { syncTours } from '../lib/sync'
import { useAuth } from './auth'

interface ToursState {
  tours: Tour[]
  loaded: boolean
  /** tour open in the detail view */
  openId: string | null
  syncing: boolean
  lastSyncError: string | null
  load: () => Promise<void>
  save: (tour: Tour) => Promise<void>
  remove: (id: string) => Promise<void>
  open: (id: string | null) => void
  sync: () => Promise<void>
}

export const useTours = create<ToursState>((set, get) => ({
  tours: [],
  loaded: false,
  openId: null,
  syncing: false,
  lastSyncError: null,

  load: async () => {
    set({ tours: await listTours(), loaded: true })
  },

  save: async (tour) => {
    await putTour({ ...tour, synced: false })
    await get().load()
    void get().sync()
  },

  remove: async (id) => {
    await deleteTour(id)
    if (get().openId === id) set({ openId: null })
    await get().load()
    void get().sync()
  },

  open: (openId) => set({ openId }),

  sync: async () => {
    if (useAuth.getState().status !== 'in' || get().syncing) return
    set({ syncing: true })
    try {
      await syncTours()
      set({ lastSyncError: null })
      await get().load()
    } catch (e) {
      set({ lastSyncError: e instanceof Error ? e.message : 'sync failed' })
    } finally {
      set({ syncing: false })
    }
  },
}))
